// extracted by mini-css-extract-plugin
export default {"confirmationContent":"buy-content_confirmationContent__bSJcc"};